import { FC, Fragment, PropsWithChildren } from 'react';
import * as Styles from './login-layout.module.less';
import { Grid, Transition } from 'semantic-ui-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { observer } from 'mobx-react';
import { LoginStore, LoginState } from '../../stores/login.store';
import { LogoST } from 'components';
import * as AuthCss from '../../../components/auth-layout/auth-layout.module.less';
import { LoginCarousel } from '../login-carousel/login-carousel';
import { Icon, Link, Tag } from '@servicetitan/design-system';
import classNames from 'classnames';
import * as FormStylesShared from '../../../styles/form-styles-shared.module.less';
import { ErrorBoundary } from '@servicetitan/error-boundary';

export const LoginLayout: FC<PropsWithChildren> = observer(({ children }) => {
    const [{ loginState, environmentInfo }] = useDependencies(LoginStore);
    const isSplashImageVisible =
        loginState !== LoginState.ResetPasswordRequest && loginState !== LoginState.Success;
    const isCornerLogoVisible = loginState !== LoginState.Success;

    return (
        <Fragment>
            <Grid.Column computer={6} tablet={16} mobile={16}>
                <Grid className={FormStylesShared.gridStyles}>
                    <Grid.Row className="p-b-7-i">
                        <Transition
                            duration={1000}
                            transitionOnMount={isSplashImageVisible}
                            animation="fade"
                            visible={isCornerLogoVisible}
                        >
                            <div
                                className={classNames(
                                    AuthCss.logoContainer,
                                    'd-f-i align-items-center'
                                )}
                            >
                                <LogoST height={66} width={61} />
                                {environmentInfo && (
                                    <Tag color="warning" className="m-l-5">
                                        {environmentInfo}
                                    </Tag>
                                )}
                            </div>
                        </Transition>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div className={FormStylesShared.form}>{children}</div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Link
                            primary
                            className="m-t-auto m-x-auto m-b-2 fs-3 d-f align-items-center"
                            href="https://www.servicetitan.com/legal/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Privacy Policy
                            <Icon className="m-l-half" name="launch" size="16" />
                        </Link>
                    </Grid.Row>
                </Grid>
            </Grid.Column>
            <Grid.Column computer={10} only="computer" className={Styles.columnRemovePadding}>
                <ErrorBoundary moduleName="login-carousel" fallback={() => <Fragment />}>
                    <LoginCarousel visible={isSplashImageVisible} />
                </ErrorBoundary>
            </Grid.Column>
        </Fragment>
    );
});
